import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  message,
  Divider,
  Table,
  Input,
  Space,
  Checkbox,
  InputNumber,
  Typography,
  Form,
  Tag,
} from "antd";
import {
  SearchOutlined,
  UnorderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const UniformesPedidosRecebimentos = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id_lote } = useParams();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [search, setSearch] = useState("");

  // DADOS LOTE
  const [lote, setLote] = useState(null);

  useEffect(() => {
    if (id_lote) {
      listarPedidos(id_lote);
      carregarLote(id_lote);
    } else {
      navigate("/uniformes/lotes-producao");
    }
  }, [id_lote]);

  // CARREGAR LOTE
  const carregarLote = async (id_lote) => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_lotes/carregar/${id_lote}`, []);
    if (api.statusCode === 200) {
      setLote(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarPedidos = async (id_lote) => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_pedidos/listar_lotes/${id_lote}`, []);
    if (api.statusCode === 200) {
      form.resetFields();

      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ATUALIZAR RECEBIMENTO
  const atualizarRecebimento = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_pedidos_recebimento/atualizar`, formulario);
    if (api.statusCode === 200) {
      message.success("Valores atualizados com sucesso!");
      listarPedidos(id_lote);
      carregarLote(id_lote);
    } else {
      carregarLote(id_lote);
      listarPedidos(id_lote);
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Solicitante",
      dataIndex: "solicitante",
      render: (_, e) => (e?.colaborador ? e.matricula + " - " + e.colaborador : e.cod_filial + " - " + e?.filial),
      sorter: (a, b) =>
        (a?.colaborador ? a.matricula + " - " + a.colaborador : a.cod_filial + " - " + a?.filial)?.localeCompare(
          b?.colaborador ? b.matricula + " - " + b.colaborador : b.cod_filial + " - " + b?.filial
        ),
      className: "fontSmall",
    },
    {
      title: "Produto",
      dataIndex: "produto",
      sorter: (a, b) => a.produto?.localeCompare(b.produto),
      className: "fontSmall",
    },
    {
      title: "Recebimento",
      dataIndex: "recebimento",
      width: 100,
      render: (_, e) =>
        e?.quantidade === e?.qtd_recebida ? (
          <Tag color="#60b565">Concluido</Tag>
        ) : (
          <Form.Item name={["recebimento", `${e?.id}`]} noStyle initialValue={0}>
            <InputNumber
              min={0}
              max={e?.quantidade - e?.qtd_recebida}
              decimalSeparator=","
              disabled={loading}
              placeholder="Informe o valor"
              style={{ width: "100%" }}
            />
          </Form.Item>
        ),
      className: "fontSmall",
    },
    {
      title: "Qtd. Pedido",
      dataIndex: "quantidade",
      sorter: (a, b) => a.quantidade?.toString()?.localeCompare(b.quantidade?.toString()),
      width: 90,
      className: "fontSmall",
    },
    {
      title: "Qtd. Recebida",
      dataIndex: "qtd_recebida",
      sorter: (a, b) => a.qtd_recebida?.toString()?.localeCompare(b.qtd_recebida?.toString()),
      width: 70,
      className: "fontSmall",
    },
    {
      title: "Adic. Manga",
      dataIndex: "adicional_manga",
      sorter: (a, b) => a.adicional_manga?.toString()?.localeCompare(b.adicional_manga?.toString()),
      width: 70,
      className: "fontSmall",
    },
    {
      title: "Adic. Altura",
      dataIndex: "adicional_altura",
      sorter: (a, b) => a.adicional_altura?.toString()?.localeCompare(b.adicional_altura?.toString()),
      width: 70,
      className: "fontSmall",
    },
    {
      title: "Valor Prod.",
      dataIndex: "valor_produtos",
      sorter: (a, b) => a.valor_produtos?.toString()?.localeCompare(b.valor_produtos?.toString()),
      width: 70,
      className: "fontSmall",
    },
    {
      title: "Valor Desc.",
      dataIndex: "valor_produtos",
      sorter: (a, b) => a.valor_desconto?.toString()?.localeCompare(b.valor_desconto?.toString()),
      width: 70,
      className: "fontSmall",
    },
    {
      title: "Valor Total",
      dataIndex: "valor_total",
      sorter: (a, b) => a.valor_total?.toString()?.localeCompare(b.valor_total?.toString()),
      width: 70,
      className: "fontSmall",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        (val?.colaborador ? val.matricula + " - " + val.colaborador : val.cod_filial + " - " + val?.filial)
          ?.toLowerCase()
          .includes(pesquisar.toLowerCase()) ||
        val.produto?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.valor_total?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.valor_produtos?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.valor_desconto?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.quantidade?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.qtd_recebida?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.adicional_manga?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.adicional_altura?.toString()?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // PREENCHER TODOS
  const marcarTodos = (val) => {
    if (val.target.checked) {
      dadosFilter.map((e) => {
        form.setFieldsValue({
          recebimento: { [e.id]: e.quantidade - e.qtd_recebida },
        });
      });
    } else {
      dadosFilter.map((e) => {
        form.setFieldsValue({ recebimento: { [e.id]: 0 } });
      });
    }
  };

  // ON SUBMIT
  const onSubmit = (formulario) => {
    if (!formulario.recebimento) return;
    formulario.id_lote = id_lote;

    atualizarRecebimento(formulario);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/uniformes/lotes-producao")} />
            <HeaderTitle
              title="Uniformes Lote Recebimentos"
              subtitle={
                <Text italic>
                  <UnorderedListOutlined /> Lote Nº {lote?.id ?? ""} - {lote?.fornecedor ?? ""}
                </Text>
              }
              icon={<FileDoneOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                {lote && lote.status !== 3 && (
                  <>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => form.submit()} loading={loading}>
                      Salvar
                    </Button>

                    <Checkbox onChange={marcarTodos}>Marcar todos</Checkbox>
                  </>
                )}
              </Space>

              <Divider />
              <Form form={form} name="register" onFinish={onSubmit} scrollToFirstError>
                <Table
                  rowKey="id"
                  loading={loading}
                  scroll={{ x: 700 }}
                  columns={columns}
                  dataSource={dadosFilter}
                  size="small"
                  pagination={false}
                />
              </Form>
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
